export const Colors = {
  seatNew: '#ADB81B',
  seatAvailable: '#D9D9D9',
  seatInactive: '#1E1E1E',
  seatActive: '#53B47F',
} as const;
